var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { ArrayMaxSize, IsArray, IsOptional, IsUUID } from 'class-validator';
import { MAX_APPOINTMENT_PARTICIPANTS } from '../appointment-participants.const.js';
/**
 * The patients to add to and remove from an appointment (#1898). A swap sends both:
 * the new patient is added before the old one leaves. Added patients get the
 * invitation; removed ones are told nothing.
 */
export class ChangeAppointmentParticipantsDto {
    add;
    remove;
}
__decorate([
    IsArray(),
    ArrayMaxSize(MAX_APPOINTMENT_PARTICIPANTS),
    IsUUID('all', { each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], ChangeAppointmentParticipantsDto.prototype, "add", void 0);
__decorate([
    IsArray(),
    ArrayMaxSize(MAX_APPOINTMENT_PARTICIPANTS),
    IsUUID('all', { each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], ChangeAppointmentParticipantsDto.prototype, "remove", void 0);
//# sourceMappingURL=change-appointment-participants.dto.js.map